import { TargetOrganization } from '../../../models/applications/directions';
import { apiSlice } from '../api-slice';

const baseUrl = `${process.env.REACT_APP_APPLICATIONS_MANAGER_API_URL}/target-organizations`;

export const targetOrganizationsApi = apiSlice.injectEndpoints({
  endpoints: builder => ({
    getAllTargetOrganizations: builder.query<TargetOrganization[], void>({
      query: () => ({
        url: `${baseUrl}/all`,
        method: 'GET',
      }),
    }),
    getTargetOrganizationsAutocomplete: builder.query<
      TargetOrganization[],
      string
    >({
      query: request => ({
        url: `${baseUrl}/autocomplete`,
        method: 'GET',
        body: request,
      }),
    }),
  }),
});
